import { SvgIcon } from '@mui/material';
import {  observer } from 'mobx-react';
import React, { Component } from 'react';
import { IPropsSvgIcone } from '../../modelo/Icone';

interface IPropsIconeTemas {

}


class IconeTemas extends Component<IPropsSvgIcone> {

    render() {
        return (
            <SvgIcon {...this.props}>

                <path fill={this.props.htmlColor || 'currentColor'}
                    d="M 2.99,13.02
                    C 2.99,13.02 3.02,20.96 3.02,20.96
                      3.02,20.96 10.98,21.00 10.98,21.00
                      10.98,21.00 10.99,13.02 10.99,13.02
                      10.99,13.02 2.99,13.02 2.99,13.02 Z
                    M 8.01,7.98
                    C 8.01,7.98 8.02,11.98 8.02,11.98
                      8.02,11.98 12.00,11.98 12.00,11.98
                      12.00,11.98 12.00,15.96 12.00,15.96
                      12.00,15.96 16.00,15.98 16.00,15.98
                      16.00,15.98 15.99,7.99 15.99,7.99
                      15.99,7.99 8.01,7.98 8.01,7.98 Z
                    M 12.02,6.99
                    C 12.02,6.99 12.02,2.96 12.02,2.96
                      12.02,2.96 21.05,3.03 21.05,3.03
                      21.05,3.03 21.02,11.99 21.02,11.99
                      21.02,11.99 17.02,12.00 17.02,12.00
                      17.02,12.00 16.99,7.00 16.99,7.00
                      16.99,7.00 12.02,6.99 12.02,6.99 Z"
                />
            </SvgIcon>
        );
    }
}

export default observer(IconeTemas);
